/** Java-style 32-bit string hash */
export function hashCode(s: string) {
  let h = 0
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0
  }
  return h
}

/** Deterministic shuffle using Fisher-Yates + LCG PRNG, returns first `limit` items */
export function seededSample<T>(items: T[], seed: number, limit: number): T[] {
  if (items.length <= limit) return items.slice()
  const indices = items.map((_, i) => i)
  let rng = seed
  for (let i = indices.length - 1; i > 0; i--) {
    rng = (Math.imul(rng, 1664525) + 1013904223) | 0
    const j = (rng >>> 0) % (i + 1)
    ;[indices[i], indices[j]] = [indices[j], indices[i]]
  }
  return indices.slice(0, limit).map(i => items[i])
}
